import { createReducer, on } from '@ngrx/store';
import { DiningAttribute } from '@shared/models/dining-attribute';
import { DiningResultsLayout } from '@shared/models/dining-results-layout.enum';
import { diningAttributesLoaded, setDiningLayout, setHeaderHeight } from './actions';

export interface SharedState {
  diningLayout: DiningResultsLayout;
  diningAttributes: DiningAttribute[];
  headerHeight: number;
}

export const initialState = {
  diningLayout: DiningResultsLayout.Default,
  diningAttributes: [],
  headerHeight: 0,
};

export const sharedReducer = createReducer(
  initialState,
  on(setDiningLayout, (state, { layout }) => ({ ...state, diningLayout: layout })),
  on(diningAttributesLoaded, (state, { attributes }) => ({ ...state, diningAttributes: attributes })),
  on(setHeaderHeight, (state, { height }) => ({ ...state, headerHeight: height }))
);
